// @ts-strict-ignore
import { useFeatureConfigUI } from '@/hooks/query/useFeatureConfig';
import type { FeedItemType } from '@/types';

import { useFetchSummarisationConfig } from './useFetchSummarisationConfig';

export const useShowSummarize = (result: UseShowSummarizeType) => {
  const { feature } = useFeatureConfigUI('doc_summarization');
  const { data: summaryConfig, isLoading: isConfigLoading } =
    useFetchSummarisationConfig();

  if (isConfigLoading || !summaryConfig || !feature) {
    return false;
  }

  if (summaryConfig.sources.includes(result.source)) {
    return true;
  } else if (
    Object.keys(summaryConfig.filters).length > 0 &&
    Object.keys(summaryConfig.filters).includes(result.source)
  ) {
    const { filterName, filterValues } = summaryConfig.filters[result.source];
    if (
      !filterName ||
      !filterValues ||
      filterValues.length === 0 ||
      !result[filterName]
    ) {
      return false;
    }

    return filterValues.includes(result[filterName]);
  }

  return false;
};

type UseShowSummarizeType = Pick<FeedItemType, 'form_ua' | 'source'>;
